import React, { useState, useEffect } from 'react';
import axios from 'axios'

function DeveloperPortal({ defaultPagePath }) {
    const [htmlPageState, setHtmlPageState] = new useState("");

    useEffect(() => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            }
        };
        let developerPortalPath = (defaultPagePath == null || defaultPagePath == undefined) ? "/static/page/gets/Compliance_Regulatory_Filling.html" : defaultPagePath;

        axios.get(process.env.PUBLIC_URL + developerPortalPath, axiosConfig).then(response => {
            setHtmlPageState(response.data)
        });
    }, []);


    //bind search button manually due to <script> not running on dangerouslySetInnerHTML
    useEffect(() => {
        const searchButton = document.getElementById("q");
        if (!searchButton) return;

        const searchHandler = () => {
            doSearch()
        };

        searchButton.addEventListener("input", searchHandler);

        // cleanup
        return () => {
            searchButton.removeEventListener("input", searchHandler);
        };

    },[htmlPageState]);

    //bind copy button manually due to <script> not running on dangerouslySetInnerHTML
    useEffect(() => {
        const copyButton = document.getElementsByClassName("copy");
        if (!copyButton) return;

        const copyHandler = (event) => {
            copyText(event.target)
        };

        for (var i = 0 ; i < copyButton.length; i++) {
            copyButton[i].addEventListener('click' , copyHandler) ; 
        }
        // cleanup
        return () => {
            for (var i = 0 ; i < copyButton.length; i++) {
                copyButton[i].removeEventListener('click' , copyHandler) ; 
            }
        };
    },[htmlPageState])

    function copyText(btn) {
        const pre = btn.parentElement.querySelector('pre');
        if (!pre) return;
        const code = pre.innerText;
        navigator.clipboard.writeText(code).then(() => {
            const old = btn.innerText;
            btn.innerText = 'Copied';
            setTimeout(() => btn.innerText = old, 1200);
        });
    }

    function doSearch() {
        const q = document.getElementById('q').value.trim().toLowerCase();
        const blocks = document.querySelectorAll('details');
        blocks.forEach(b => {
            const t = (b.querySelector('summary')?.innerText || '').toLowerCase();
            b.classList.toggle('hidden', q && !t.includes(q));
        });
    }

    return (
        <div style={{ padding: '5px' }} dangerouslySetInnerHTML={{ __html: htmlPageState }} />
    )
}

export default DeveloperPortal; 